export default __webpack_public_path__ + "static/media/6.9d9f94a0.png";